import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFavorite } from '../../../interfaces/account/favorite/IFavorite.ts';
import { IFavoriteDto } from '../../../response/account/getMeResponse.ts';
import { FavoriteTypeEnum } from '../../../types/account/favoriteTypeTypes.ts';

interface IAccountFavoriteStates {
    items: IFavorite[];
}

const initialState: IAccountFavoriteStates = {
    items: [],
};

export const accountFavoritesSlice = createSlice({
    name: 'account-favorites',
    initialState: initialState,
    reducers: {
        updateAll: (state, action: PayloadAction<{
            favorites: IFavorite[],
        }>) => {
            state.items = action.payload.favorites;
        },
        updateAllFromDTO: (state, action: PayloadAction<IFavoriteDto[]>) => {
            state.items = action.payload.map((item): IFavorite => ({
                id: item.id,
                name: item.name,
                type: item.type,
                position: item.position,
                searchQuery: item.search_query,
            }));
        },
        removeFavorite: (state, action: PayloadAction<string>) => {
            state.items = state.items.filter((item) => item.id !== action.payload);
        },
        addFavorite: (state, action: PayloadAction<{ id: string, name: string, type: FavoriteTypeEnum }>) => {
            let position = 1;
            if (state.items.length > 0) {
                const sortedListDesc = state.items.sort((a, b) => b.position - a.position);
                position = sortedListDesc[0].position + 1;
            }
            const newFavorite: IFavorite = {
                name: action.payload.name,
                id: action.payload.id,
                position,
                type: action.payload.type,
                searchQuery: action.payload.name.toLowerCase(),
            };
            state.items = [...state.items, newFavorite];
        },
    },
});

export const accountFavoritesActions = accountFavoritesSlice.actions;